"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import ErrorPage from "@/app/components/errorPage";

/**
 * App Router 路由段错误 UI：捕获本段内子路由 / page 等渲染错误，并提供 reset。
 * 与 RootErrorBoundary 配合：Provider 等在 page「之上」的异常由 RootErrorBoundary 兜住。
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { errorBoundary: "app/error" },
      extra: { digest: error.digest },
    });
  }, [error]);

  return <ErrorPage errorMsg={error.message || ""} canRetry onRetry={reset} />;
}
